import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'shared-link',
    templateUrl: './link.shared.component.html',
    styleUrls: ['./link.shared.component.scss']
})
export class LinkComponent implements OnInit {
    @Input() public mobile: boolean = false;
    @Input() public emphasis: boolean = true;
    @Input() public inverted: boolean = false;
    @Input() public label: string;
    @Input() public icon: string;
    @Input() public size: OLO.Components.LINK_SIZE = null;
    @Input() public disabled: boolean = false;
    @Input() public isAsync: boolean = false;
    @Input() public title: string = '';
    @Input() public role: string = 'button';

    /* For routerLink */
    @Input() public routerLink: string | any[];
    @Input() public queryParams: { [k: string]: any; };
    @Input() public fragment: string;
    @Input() public queryParamsHandling: any; /* QueryParamsHandling */
    @Input() public preserveFragment: boolean;
    @Input() public skipLocationChange: boolean;
    @Input() public replaceUrl: boolean;
    @Input() public state?: { [k: string]: any; };

    @Output() public onClick: EventEmitter<Event> = new EventEmitter(this.isAsync);

    constructor() { }

    ngOnInit(): void { }

    public btnClick($event: Event): void {
        if (this.disabled) {
            $event.preventDefault();
            return;
        }

        this.onClick.emit($event);
    }
}
